import { render } from "./CustomInputTextArea.vue?vue&type=template&id=1211df38"
import script from "./CustomInputTextArea.vue?vue&type=script&lang=js"
export * from "./CustomInputTextArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__